import React from 'react';
import { Hero } from '../components/Hero';
import { ValueProp } from '../components/ValueProp';
import { About as AboutSection } from '../components/About';
import { HowItWorks } from '../components/HowItWorks';
import { Services as ServicesSection } from '../components/Services';
import { Specialists } from '../components/Specialists';
import { Appointment } from '../components/Appointment';
import { Testimonials } from '../components/Testimonials';
import { Blog } from '../components/Blog';
import { FAQ } from '../components/FAQ';
import { DownloadApp } from '../components/DownloadApp';
import { CTA } from '../components/CTA';

export const Home: React.FC = () => {
  return (
    <>
      <Hero />
      <ValueProp />
      <AboutSection />
      <HowItWorks />
      <ServicesSection />
      <Specialists />
      <Appointment />
      <Testimonials />
      <Blog />
      <FAQ />
      <DownloadApp />
      <CTA />
    </>
  );
};